var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLinkedin = function SvgLinkedin(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 42 42",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M37 0H5C2.24 0 0 2.24 0 5v32c0 2.76 2.24 5 5 5h32c2.76 0 5-2.24 5-5V5c0-2.76-2.24-5-5-5ZM13 16v19H7V16h6Zm-6-5.53C7 9.07 8.2 8 10 8s2.93 1.07 3 2.47c0 1.4-1.12 2.53-3 2.53-1.8 0-3-1.13-3-2.53ZM35 35h-6V25c0-2-1-4-3.5-4.04h-.08C23 20.96 22 23.02 22 25v10h-6V16h6v2.56S23.93 16 27.81 16c3.97 0 7.19 2.73 7.19 8.26V35Z"
  })));
};
export default SvgLinkedin;